import axios from "axios";
import {Notify} from "vant"
import store from "@/store";

const service = axios.create({
    baseURL: '/apis',
    timeout: 90000,
    withCredentials: true
})
//请求拦截器
service.interceptors.request.use(
    config => {
        if (store.getters.token) {
            config.headers.Authorization = 'Bearer ' + store.getters.token;
        }
        return config
    }, error => {
        console.log(error)
        return Promise.reject(error)
    })
//响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        if (res.code !== 200) {
            Notify({type: 'danger', message: '❌ ' + (res.msg || '系统错误'), duration: 1000});
            // 201 = 登录失效：清 token 并跳登录页。
            // 不用 location.reload()（无路由守卫时，重载会再次请求接口、再得 201、无限刷新）；
            // 路由为 hash 模式，改 hash 即触发 Vue Router 跳转，登录页本身无鉴权接口、不会再次 201。
            if (res.code === 201) {
                store.dispatch('user/resetToken').finally(() => {
                    if (window.location.hash !== '#/login') {
                        window.location.hash = '#/login';
                    }
                });
            }
            return Promise.reject(new Error(res.msg || 'Error'))
        } else {
            return res
        }
    }, error => {
        // 网络/超时/5xx 统一转成友好中文提示，不暴露技术细节
        let message = '网络开小差了，请检查连接后重试';
        if (error && error.message && error.message.indexOf('timeout') !== -1) {
            message = '请求超时，请稍后再试';
        } else if (error && error.response && error.response.status >= 500) {
            message = '服务器打盹了，请稍后再试';
        }
        Notify({type: 'danger', message: '❌ ' + message, duration: 1500});
        return Promise.reject(error)
    })
export default service